import {
  accountDescription,
  assetDescription,
  buildEntityDescriptions,
  declareCommentaryContext,
  describeEntity,
  externalTransactionDescription,
} from '@helios/comments'
import { ExternalTransaction } from '@helios/common-api'

export const externalTransactionCommentary =
  declareCommentaryContext<ExternalTransaction>()({
    fields: [
      'accountId',
      'accountName',
      'extTranId',
      'secIdentifier',
      'tranTypeCode',
      'amount',
      'units',
      'tradeDate',
    ],
    build: tx => {
      const extTranId = tx.extTranId.toString()
      return {
        accountId: tx.accountId?.toString(),
        extTranId,
        assetId: tx.secIdentifier,
        entityDescriptions: buildEntityDescriptions([
          describeEntity(
            'account',
            tx.accountId,
            accountDescription({ accountName: tx.accountName }),
          ),
          describeEntity(
            'exttran',
            extTranId,
            externalTransactionDescription({
              tranTypeCode: tx.tranTypeCode,
              amount: tx.amount,
              units: tx.units,
              tradeDate: tx.tradeDate,
              secIdentifier: tx.secIdentifier,
            }),
          ),
          describeEntity(
            'asset',
            tx.secIdentifier,
            assetDescription({ secIdentifier: tx.secIdentifier }),
          ),
        ]),
      }
    },
  })
